import ReactECharts from "echarts-for-react";
import React, { Component } from "react";
import EChartsReact from "echarts-for-react";
import { ACTIVITY_COUNT } from "../../../api/types";
interface AppProp {
	value: Array<any>;
	month: Array<string>;
	topic: boolean;
	onDownload: (urls: [string, string]) => void;
}
const displayRealm = [
	"Elixir Institute",
	"Pythagoras Peninsula",
	"Fahren Heights",
	"Prehistoric Point",
	"Green Acres",
	"Habiterra",
	"DNAtion",
	"Cape Cosmos",
	"Edison Avenue",
	"E=MC Square",
];
const displayTopic = [
	"Medicine & Health",
	"Mathematics",
	"Weather",
	"Dinosaurs & Fossils",
	"Environment & Nature",
	"Animals",
	"Life & Evolution",
	"Space",
	"Inventions",
	"Physics",
];
export class ActivityCount extends Component<AppProp, {}> {
	private echartsRef: React.RefObject<EChartsReact>;

	private onDownload: (urls: [string, string]) => void;

	constructor(props: AppProp) {
		super(props);
		this.echartsRef = React.createRef();
		this.onDownload = props.onDownload;
		this.state = { imgUrl: "" };
	}

	componentDidUpdate(
		_prevProps: Readonly<AppProp>,
		prevState: { imgUrl: string },
	): void {
		// @ts-ignore
		const base64: string = this.echartsRef.current
			.getEchartsInstance()
			.getDataURL();
		if (prevState.imgUrl !== base64) {
			this.setState({ imgUrl: base64 });
			this.onDownload([ACTIVITY_COUNT, base64]);
		}
	}

	getData(name: string, dict: Array<any>): Array<number> {
		const output = [];
		for (const item of dict) {
			if (name in item) {
				output.push(item[name]);
			} else {
				output.push(0);
			}
		}
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return output;
	}

	getOption(activity: Array<any>, month: Array<string>): Object {
		return {
			title: {
				text: "Activities Count",
			},
			tooltip: {
				trigger: "axis",
				axisPointer: {
					// Use axis to trigger tooltip
					type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
				},
			},
			// legend: {
			// 	orient: "vertical",
			// 	right: 0,
			// 	top: "center",
			// },
			// color: ["#DD4E42","#F18458","#F1D25B","#D2C39F","#8FC181","#73DCCD","#CEE7F5","#6272D1","#8B5AA3","#FCC2D7",],
			grid: {
				left: "3%",
				right: "4%",
				bottom: "1%",
				containLabel: true,
				height: "80%",
				width: "80%",
			},
			yAxis: {
				type: "value",
			},
			xAxis: {
				type: "category",
				data: month,
			},
			series: [
				{
					name: this.props.topic ? displayTopic[0]! : displayRealm[0]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#DD4E42",
					data: this.getData("Elixir Institute", activity),
				},
				{
					name: this.props.topic ? displayTopic[1]! : displayRealm[1]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#F18458",
					data: this.getData("Pythagoras Peninsula", activity),
				},
				{
					name: this.props.topic ? displayTopic[2]! : displayRealm[2]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#F1D25B",
					data: this.getData("Fahren Heights", activity),
				},
				{
					name: this.props.topic ? displayTopic[3]! : displayRealm[3]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#D2C39F",
					data: this.getData("Prehistoric Point", activity),
				},
				{
					name: this.props.topic ? displayTopic[4]! : displayRealm[4]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#8FC181",
					data: this.getData("Green Acres", activity),
				},
				{
					name: this.props.topic ? displayTopic[5]! : displayRealm[5]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#73DCCD",
					data: this.getData("Habiterra", activity),
				},
				{
					name: this.props.topic ? displayTopic[6]! : displayRealm[6]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#CEE7F5",
					data: this.getData("DNAtion", activity),
				},
				{
					name: this.props.topic ? displayTopic[7]! : displayRealm[7]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#6272D1",
					data: this.getData("Cape Cosmos", activity),
				},
				{
					name: this.props.topic ? displayTopic[8]! : displayRealm[8]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#8B5AA3",
					data: this.getData("Edison Avenue", activity),
				},
				{
					name: this.props.topic ? displayTopic[9]! : displayRealm[9]!,
					type: "bar",
					stack: "total",
					emphasis: {
						focus: "series",
					},
					color: "#FCC2D7",
					data: this.getData("E=MC Square", activity),
				},
			],
		};
	}

	render(): JSX.Element {
		return (
			<ReactECharts
				ref={this.echartsRef}
				option={this.getOption(this.props.value, this.props.month)}
				// style={{height: '250px', width: '500px'}}
			/>
		);
	}
}
